import Userback from "@userback/widget";
import type { UserbackFeedbackType, UserbackWidget } from "@userback/widget";

const USERBACK_TOKEN = "A-JKwXdXKpC6k3HViZ51CEnHHPy";

async function loadUserback(): Promise<UserbackWidget | undefined> {
  try {
    return await Userback(USERBACK_TOKEN);
  } catch (error) {
    console.warn("Userbackの初期化に失敗しました。", error);
    return undefined;
  }
}

export async function initUserback(): Promise<void> {
  await loadUserback();
}

export async function openUserbackForm(
  feedbackType: UserbackFeedbackType,
): Promise<void> {
  const userback = await loadUserback();
  userback?.openForm(feedbackType, "form");
}

export async function hideUserbackLauncher(): Promise<void> {
  const userback = await loadUserback();
  userback?.hideLauncher();
}

export async function showUserbackLauncher(): Promise<void> {
  const userback = await loadUserback();
  userback?.showLauncher();
}
